module.exports = __webpack_public_path__ + "b35ae900f23a148d96fdd013cfb955c4.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Light.eot
// module id = 689
// module chunks = 0